export default {
  noPrivileges: {
    title: 'noPrivilegesTitle',
    subtitle: 'noPrivilegesSubtitle',
  },
  noPrivilegesAllModules: {
    title: 'splashScreen.noPrivilegesAllModules.title',
    subtitle: 'splashScreen.noPrivilegesAllModules.subTitle',
  },
  noPrivilegesModule: {
    title: 'noPrivilegesModuleTitle',
    subtitle: 'noPrivilegesModuleSubtitle',
  },
  noPrivilegesWebsite: {
    title: 'noPrivilegesWebsiteTitle',
    subtitle: 'noPrivilegesWebsiteSubtitle',
  },
  notFound: {
    title: 'notFoundTitle',
    subtitle: 'notFoundSubtitle',
  },
  noWebsiteSelected: {
    title: 'splashScreen.noWebsiteSelected.title',
    subtitle: 'splashScreen.noWebsiteSelected.subtitle',
  },
  websiteNotExist: {
    title: 'splashScreen.websiteNotExist.title',
    subtitle: 'splashScreen.websiteNotExist.subtitle',
  },
  noMetaSiteSupport: {
    title: 'splashScreen.noMetaSiteSupport.title',
    subtitle: 'splashScreen.noMetaSiteSupport.subtitle',
  },
  noLicense: {
    title: 'splashScreen.noLicense.title',
    subtitle: 'splashScreen.noLicense.subtitle',
  },
  noLicenseForModule: {
    title: 'splashScreen.noLicenseForModule.title',
    subtitle: 'splashScreen.noLicenseForModule.subtitle',
  },
  activeLicenseForModule: {
    title: 'splashScreen.activeLicenseForModule.title',
    subtitle: 'splashScreen.activeLicenseForModule.subtitle',
  },
  internalServerError: {
    title: 'splashScreen.internalServerError.title',
    subtitle: 'splashScreen.internalServerError.subtitle',
  },
  maintenanceMode: {
    title: 'splashScreen.maintenanceMode.title',
    subtitle: 'splashScreen.maintenanceMode.subtitle',
  },
  noAppOrPrivileges: {
    title: 'splashScreen.noAppOrPrivileges.title',
    subtitle: 'splashScreen.noAppOrPrivileges.subtitle',
  },
  // Analytics specific message
  noAnalyticsData: {
    title: 'splashScreen.noAnalyticsData.title',
    subtitle: 'splashScreen.noAnalyticsData.subtitle',
  },
  // Analytics specific message
  websocketError: {
    title: 'splashScreen.websocketError.title',
    subtitle: 'splashScreen.websocketError.subtitle',
  },
  // Analytics specific message
  adBlockEnabled: {
    title: 'splashScreen.adBlockEnabled.title',
    subtitle: 'splashScreen.adBlockEnabled.subtitle',
  },
  // CDP specific message
  profilesExportError: {
    title: 'splashScreen.profilesExportError.title',
    subtitle: 'splashScreen.profilesExportError.subtitle',
  },
  // Custom (display children only)
  custom: {},
};
